import composeHooks from '../../helpers/composeHooks'

import SideNav, { SideNavProps } from './SideNav'
import useSideNav from './SideNav.hooks'

type SideNavContainerProps = Omit<SideNavProps, 'progresses'>

export default composeHooks<SideNavContainerProps, SideNavProps>({ useSideNav })(SideNav)
